module.exports = __webpack_public_path__ + "static/media/early-warning-signs@2x.05abe764.png";